export const DAAS_TOKEN_METADATA_CACHE = 'daas-token-metadata';
export const DAAS_COLLECTION_METADATA_CACHE = 'daas-collection-metadata';
export const DAAS_COLLECTION_TOKEN_COUNT_CACHE = 'daas-collection-token-count';
export const DAAS_COLLECTION_OWNERS_COUNT = 'daas-collection-owners-count';
export const DAAS_COLLECTION_TRAITS = 'daas-collection-traits';
export const DAAS_ACTIVE_LISTINGS = 'daas-active-listings';
export const DAAS_LISTINGS_BY_SOURCE = 'daas-listings-by-source';
